(function () {
  var FALLBACK = {
    "Dark Brown": "#3d2b1f",
    "Stretched Canvas": "#1a1a1a"
  };
  var HOLES = {
    landscape: {
      Black: { x: 48 / 1080, y: 153 / 1082, w: 976 / 1080, h: 770 / 1082 },
      White: { x: 21 / 1080, y: 120 / 1082, w: 1032 / 1080, h: 831 / 1082 },
      Wooden: { x: 47 / 1080, y: 154 / 1082, w: 978 / 1080, h: 772 / 1082 }
    },
    portrait: {
      Black: { x: 145 / 1080, y: 40 / 1080, w: 788 / 1080, h: 994 / 1080 },
      White: { x: 120 / 1080, y: 14 / 1080, w: 843 / 1080, h: 1049 / 1080 },
      Wooden: { x: 145 / 1080, y: 40 / 1080, w: 788 / 1080, h: 994 / 1080 }
    },
    square: {
      Black: { x: 71 / 1080, y: 72 / 1080, w: 941 / 1080, h: 939 / 1080 },
      White: { x: 39 / 1080, y: 35 / 1080, w: 1004 / 1080, h: 1008 / 1080 },
      Wooden: { x: 71 / 1080, y: 75 / 1080, w: 940 / 1080, h: 936 / 1080 }
    }
  };

  function loadImage(src, cors) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (cors !== false) img.crossOrigin = "anonymous";
      img.onload = function () { resolve(img); };
      img.onerror = function () {
        if (cors !== false) loadImage(src, false).then(resolve, reject);
        else reject(new Error("image"));
      };
      img.src = src;
    });
  }

  function cover(ctx, img, x, y, w, h) {
    var ir = img.width / img.height;
    var r = w / h;
    var sx = 0;
    var sy = 0;
    var sw = img.width;
    var sh = img.height;
    if (ir > r) {
      sw = sh * r;
      sx = (img.width - sw) / 2;
    } else {
      sh = sw / r;
      sy = (img.height - sh) / 2;
    }
    ctx.drawImage(img, sx, sy, sw, sh, x, y, w, h);
  }

  function holeOf(img, orientation, color) {
    var spec = (HOLES[orientation] || {})[color];
    if (!spec || !img) return null;
    return {
      x: Math.round(spec.x * img.width),
      y: Math.round(spec.y * img.height),
      w: Math.round(spec.w * img.width),
      h: Math.round(spec.h * img.height)
    };
  }

  function composite(photo, frameImg, orientation, color) {
    var out = document.createElement("canvas");
    out.width = frameImg.width;
    out.height = frameImg.height;
    var ctx = out.getContext("2d");
    ctx.drawImage(frameImg, 0, 0);
    var hole = holeOf(frameImg, orientation, color);
    if (hole) cover(ctx, photo, hole.x, hole.y, hole.w, hole.h);
    return out;
  }

  function drawFallback(photo, colorName, orientation) {
    var landscape = orientation === "landscape";
    var square = orientation === "square";
    var w = square ? 900 : landscape ? 1100 : 800;
    var h = square ? 900 : landscape ? 800 : 1100;
    var out = document.createElement("canvas");
    out.width = w;
    out.height = h;
    var ctx = out.getContext("2d");
    var edge = Math.round(Math.min(w, h) * 0.045);
    var mat = Math.round(Math.min(w, h) * 0.07);
    ctx.fillStyle = FALLBACK[colorName] || "#111";
    ctx.fillRect(0, 0, w, h);
    if (colorName !== "Stretched Canvas") {
      ctx.fillStyle = "#f7f4ef";
      ctx.fillRect(edge, edge, w - edge * 2, h - edge * 2);
      cover(ctx, photo, edge + mat, edge + mat, w - (edge + mat) * 2, h - (edge + mat) * 2);
    } else {
      cover(ctx, photo, edge, edge, w - edge * 2, h - edge * 2);
    }
    return out;
  }

  window.PaintroadPersonalise = {
    composite: composite,
    drawFallback: drawFallback,
    loadImage: loadImage
  };

  function formatMoney(cents, format) {
    var amount = (Number(cents) || 0) / 100;
    var text = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(amount);
    if (format && format.indexOf("amount") !== -1) {
      return format.replace(/\{\{\s*amount[^}]*\}\}/, text);
    }
    return "₹" + text;
  }

  function optionValue(variant, product, name) {
    var i = (product.optionNames || []).findIndex(function (n) {
      return String(n).toLowerCase() === name;
    });
    if (i < 0) return "";
    return variant["o" + (i + 1)] || "";
  }

  function fromJsProduct(p) {
    return {
      handle: p.handle,
      title: p.title,
      optionNames: (p.options || []).map(function (o) { return o.name || o; }),
      variants: (p.variants || []).map(function (v) {
        return { id: v.id, available: v.available, price: v.price, o1: v.option1, o2: v.option2, o3: v.option3 };
      })
    };
  }

  function orientationOf(w, h) {
    if (!w || !h) return "landscape";
    var ratio = w / h;
    if (ratio > 0.92 && ratio < 1.08) return "square";
    return w > h ? "landscape" : "portrait";
  }

  function paintCanvas(target, source) {
    if (!target || !source) return;
    target.width = source.width;
    target.height = source.height;
    target.getContext("2d").drawImage(source, 0, 0);
  }

  function swatch(name) {
    var map = {
      Black: "#121110",
      White: "#f4f1ea",
      Wooden: "#c6924a",
      "Dark Brown": "#3d2b1f",
      "Stretched Canvas": "#ded8d0"
    };
    return map[name] || "#ccc";
  }

  function initPage(root) {
    var cfgEl = root.querySelector("[data-pr-config]");
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent || "{}");
    var base = cfg.product;
    var frames = cfg.frames || {};
    var state = {
      file: null,
      photo: null,
      existingPrint: "",
      orientation: "",
      product: base,
      frame: "",
      variantId: null,
      lineKey: "",
      originalVariantId: "",
      quantity: 1
    };
    var products = {};
    products[base.handle] = base;

    function $(sel) { return root.querySelector(sel); }
    function showError(msg) {
      var el = $("[data-error]");
      if (!el) return;
      el.hidden = !msg;
      el.textContent = msg || "";
    }

    function loadProduct(handle) {
      if (!handle || products[handle]) return Promise.resolve(products[handle] || base);
      return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var shaped = p && p.variants && p.variants.length ? fromJsProduct(p) : base;
          products[shaped.handle] = shaped;
          return shaped;
        })
        .catch(function () { return base; });
    }

    function variantsForFrame() {
      return (state.product.variants || []).filter(function (v) {
        if (v.available === false) return false;
        var frame = optionValue(v, state.product, "frame");
        return !state.frame || !frame || frame === state.frame;
      });
    }

    function setOrientationLabel() {
      var el = $("[data-orient]");
      if (!el) return;
      if (!state.orientation) {
        el.textContent = "Upload to detect orientation";
        return;
      }
      el.textContent = state.orientation.charAt(0).toUpperCase() + state.orientation.slice(1);
    }

    function renderFrames() {
      var box = $("[data-frames]");
      if (!box) return;
      var seen = {};
      var colors = [];
      (state.product.variants || []).forEach(function (v) {
        if (v.available === false) return;
        var name = optionValue(v, state.product, "frame");
        if (!name || seen[name]) return;
        seen[name] = true;
        colors.push(name);
      });
      if (!colors.length) colors = ["Black", "White", "Wooden"];
      if (!seen[state.frame]) state.frame = colors[0];
      box.innerHTML = "";
      colors.forEach(function (name) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pr-pers__choice" + (name === state.frame ? " is-on" : "");
        var sw = document.createElement("i");
        sw.className = "pr-pers__swatch";
        sw.style.background = swatch(name);
        btn.appendChild(sw);
        btn.appendChild(document.createTextNode(name));
        btn.addEventListener("click", function () {
          state.frame = name;
          renderFrames();
          renderSizes();
          renderArt();
        });
        box.appendChild(btn);
      });
    }

    function renderSizes() {
      var box = $("[data-sizes]");
      if (!box) return;
      var list = variantsForFrame();
      if (!list.some(function (v) { return String(v.id) === String(state.variantId); })) {
        state.variantId = list.length ? list[0].id : null;
      }
      box.innerHTML = "";
      list.forEach(function (v) {
        var size = optionValue(v, state.product, "size") || "Size";
        var material = optionValue(v, state.product, "material");
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pr-pers__choice" + (String(v.id) === String(state.variantId) ? " is-on" : "");
        var label = document.createElement("span");
        label.textContent = size;
        if (material) {
          var sub = document.createElement("small");
          sub.textContent = material;
          label.appendChild(sub);
        }
        btn.appendChild(label);
        btn.addEventListener("click", function () {
          state.variantId = v.id;
          renderSizes();
        });
        box.appendChild(btn);
      });
      var chosen = list.filter(function (v) { return String(v.id) === String(state.variantId); })[0];
      var priceEl = $("[data-price]");
      if (priceEl) priceEl.textContent = chosen ? formatMoney(chosen.price, cfg.moneyFormat) : "";
      var add = $("[data-add]");
      var buy = $("[data-buy]");
      var ready = !!(state.photo || state.existingPrint);
      if (buy) buy.hidden = !ready;
      if (add) {
        add.textContent = state.lineKey ? "Update cart" : "Add to cart";
        add.disabled = !chosen || !ready;
      }
    }

    function renderArt() {
      if (!state.photo) return;
      var set = frames[state.orientation] || {};
      var url = set[state.frame];
      var draw = function (canvas) {
        paintCanvas($("[data-frame-canvas]"), canvas);
      };
      if (!url) {
        draw(drawFallback(state.photo, state.frame, state.orientation));
        return;
      }
      loadImage(url).then(function (frameImg) {
        draw(composite(state.photo, frameImg, state.orientation, state.frame));
      }).catch(function () {
        draw(drawFallback(state.photo, state.frame, state.orientation));
      });
    }

    function showPreview(src) {
      var preview = $("[data-preview]");
      var drop = $("[data-drop]");
      if (drop) drop.hidden = true;
      if (preview) preview.hidden = false;
    }

    function hidePreview() {
      var preview = $("[data-preview]");
      var drop = $("[data-drop]");
      if (preview) preview.hidden = true;
      if (drop) drop.hidden = false;
    }

    function applyPhoto(file) {
      var okType = /^image\/(jpeg|png|webp)$/.test(file.type) || /\.(jpe?g|png|webp)$/i.test(file.name);
      if (!okType) {
        showError("Please use a JPG, PNG, or WebP photo.");
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        showError("That photo is over 20 MB. Please choose a smaller file.");
        return;
      }
      showError("");
      if (state.photo && String(state.photo.src).indexOf("blob:") === 0) URL.revokeObjectURL(state.photo.src);
      state.file = file;
      var url = URL.createObjectURL(file);
      loadImage(url).then(function (img) {
        state.photo = img;
        state.orientation = orientationOf(img.naturalWidth || img.width, img.naturalHeight || img.height);
        setOrientationLabel();
        showPreview(url);
        var handle = (cfg.handles && cfg.handles[state.orientation]) || base.handle;
        return loadProduct(handle);
      }).then(function (product) {
        state.product = product || base;
        state.frame = state.frame || "";
        state.variantId = null;
        renderFrames();
        renderSizes();
        renderArt();
      }).catch(function () {
        showError("We couldn’t read that photo. Please try another file.");
      });
    }

    root.querySelectorAll("[data-pick]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-pick");
        var input = root.querySelector('[data-file="' + key + '"]') || root.querySelector('[data-file="files"]');
        if (input) input.click();
      });
    });
    root.querySelectorAll("[data-file]").forEach(function (input) {
      input.addEventListener("change", function () {
        var file = input.files && input.files[0];
        input.value = "";
        if (file) applyPhoto(file);
      });
    });
    var remove = $("[data-remove]");
    if (remove) {
      remove.addEventListener("click", function () {
        if (state.photo && String(state.photo.src).indexOf("blob:") === 0) URL.revokeObjectURL(state.photo.src);
        state.file = null;
        state.photo = null;
        state.existingPrint = state.lineKey ? state.existingPrint : "";
        if (!state.existingPrint) {
          state.orientation = "";
          hidePreview();
          setOrientationLabel();
          var buy = $("[data-buy]");
          if (buy) buy.hidden = true;
        }
      });
    }

    renderFrames();
    renderSizes();
    setOrientationLabel();

    var add = $("[data-add]");
    if (add) {
      add.addEventListener("click", function () {
        var err = $("[data-cart-error]");
        if (!state.variantId || (!state.file && !state.existingPrint)) return;
        add.disabled = true;
        var body = new FormData();
        body.append("id", String(state.variantId));
        body.append("quantity", String(state.quantity || 1));
        body.append("properties[_Orientation]", state.orientation);
        if (state.file) body.append("properties[Print]", state.file);
        else body.append("properties[Print]", state.existingPrint);
        var finish = function () {
          window.location.href = cfg.cartUrl || "/cart";
        };
        var sameLine = state.lineKey && !state.file && String(state.variantId) === String(state.originalVariantId);
        var request = sameLine
          ? fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({
                id: state.lineKey,
                quantity: state.quantity || 1,
                properties: { Print: state.existingPrint, _Orientation: state.orientation }
              })
            })
          : fetch("/cart/add.js", { method: "POST", body: body, headers: { Accept: "application/json" } });
        request
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || "Could not add this to the cart."); });
            if (!state.lineKey || sameLine) return null;
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: state.lineKey, quantity: 0 })
            });
          })
          .then(finish)
          .catch(function (e) {
            add.disabled = false;
            if (err) {
              err.hidden = false;
              err.textContent = e.message || "Could not update the cart.";
            }
          });
      });
    }

    var params = new URLSearchParams(window.location.search);
    var line = params.get("line");
    if (!line) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = (cart.items || []).filter(function (it) { return it.key === line; })[0];
        if (!item) return;
        state.lineKey = item.key;
        state.quantity = item.quantity || 1;
        state.variantId = item.variant_id;
        state.originalVariantId = item.variant_id;
        state.existingPrint = (item.properties && (item.properties.Print || item.properties.print)) || "";
        state.orientation = (item.properties && item.properties._Orientation) || "";
        (item.options_with_values || []).forEach(function (opt) {
          if (String(opt.name).toLowerCase() === "frame") state.frame = opt.value;
        });
        setOrientationLabel();
        var handle = (cfg.handles && cfg.handles[state.orientation]) || item.handle || base.handle;
        return loadProduct(handle).then(function (product) {
          state.product = product || base;
          if (!state.existingPrint) {
            renderFrames();
            renderSizes();
            return;
          }
          return loadImage(state.existingPrint).then(function (img) {
            state.photo = img;
            if (!state.orientation) {
              state.orientation = orientationOf(img.naturalWidth || img.width, img.naturalHeight || img.height);
              setOrientationLabel();
            }
            showPreview(state.existingPrint);
            renderFrames();
            renderSizes();
            renderArt();
          });
        });
      })
      .catch(function () {});
  }

  function frameCartImages() {
    var cfgEl = document.getElementById("PrFrameAssets");
    if (!cfgEl || !window.PaintroadPersonalise) return;
    var frames;
    try { frames = JSON.parse(cfgEl.textContent || "{}"); } catch (e) { return; }
    document.querySelectorAll(".pr-personalise-cart-img").forEach(function (img) {
      if (img.getAttribute("data-pr-framed")) return;
      var print = img.getAttribute("data-pr-print");
      var color = img.getAttribute("data-pr-frame") || "Black";
      var orient = img.getAttribute("data-pr-orient") || "landscape";
      var url = frames[orient] && frames[orient][color];
      img.setAttribute("data-pr-framed", "pending");
      if (!print) return;
      var photoP = loadImage(print);
      var frameP = url ? loadImage(url) : Promise.reject();
      Promise.all([photoP, frameP]).then(function (pair) {
        var art = composite(pair[0], pair[1], orient, color);
        img.src = art.toDataURL("image/jpeg", 0.86);
        img.setAttribute("data-pr-framed", "1");
      }).catch(function () {
        photoP.then(function (photo) {
          if (FALLBACK[color]) {
            var art = drawFallback(photo, color, orient);
            img.src = art.toDataURL("image/jpeg", 0.86);
          }
          img.setAttribute("data-pr-framed", "1");
        }).catch(function () {
          img.setAttribute("data-pr-framed", "photo");
        });
      });
    });
  }

  function boot() {
    var root = document.querySelector("[data-pr-personalise]");
    if (root) initPage(root);
    frameCartImages();
    if (window.MutationObserver) {
      new MutationObserver(function () { frameCartImages(); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
